import { render, staticRenderFns } from "./SearchTabTheme2.vue?vue&type=template&id=46823252&scoped=true"
import script from "./SearchTabTheme2.vue?vue&type=script&lang=js"
export * from "./SearchTabTheme2.vue?vue&type=script&lang=js"
import style0 from "./SearchTabTheme2.vue?vue&type=style&index=0&id=46823252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46823252",
  null
  
)

export default component.exports